import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Button, Form, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fetchHistoricalManualValidations, fetchTurmericData, fetchCorianderHistoryData, fetchRTCData } from "./API/Api";

export default function InfoHeader() {
    const [headerInfo, setHeaderInfo] = useState({
        date: "",
        time: "",
        currentShift: ""
    });


    // Historical modal state
    const [showHistoricalModal, setShowHistoricalModal] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [isLoadingHistorical, setIsLoadingHistorical] = useState(false);
    const [historicalData, setHistoricalData] = useState(null);
    const [aiDetectedData, setAiDetectedData] = useState(null);






    useEffect(() => {
        const updateDateTime = () => {
            const now = new Date();

            const date = now.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric"
            });

            const time = now.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true
            });

            const currentTime = now.getHours() * 60 + now.getMinutes(); // minutes since midnight

            let shift = "";
            if (currentTime >= 420 && currentTime < 930) {
                // 7:00 AM to 3:30 PM
                shift = "I";
            } else if (currentTime >= 930 && currentTime < 1440) {
                // 3:30 PM to 12:00 AM
                shift = "II";
            } else {
                // 12:00 AM to 7:00 AM
                shift = "III";
            }

            setHeaderInfo({ date, time, currentShift: shift });
        };

        updateDateTime(); // Initial run
        const interval = setInterval(updateDateTime, 60 * 1000); // Update every minute

        return () => clearInterval(interval); // Cleanup
    }, []);

    return (

        <div style={{ textAlign: "center" }}>
            <Row>
                <Col xs={12}>
                    <div className="d-flex flex-wrap header-info-bar">
                        <div className="header-info-item">
                            <span className="info-label">Date: </span>
                            <span className="info-value">{headerInfo.date}</span>
                        </div>
                        <div className="header-info-item">
                            <span className="info-label">Time: </span>
                            <span className="info-value">{headerInfo.time}</span>
                        </div>
                        <div className="header-info-item">
                            <span className="info-label">Current Shift: </span>
                            <span className="info-value">{headerInfo.currentShift}</span>
                        </div>
                        <button
                            type="button"
                            onClick={() => setShowHistoricalModal(true)}
                            title="Click to view historical manual validation values"
                            style={{
                                backgroundColor: "#0d6efd",   // blue
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "6px",
                                padding: "8px 14px",
                                fontSize: "14px",
                                fontWeight: 500,
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)"
                            }}
                        >
                            View Historical Manual Validations
                        </button>



                    </div>
                </Col>
            </Row>

            {/* Historical Manual Validations Modal */}
            <Modal show={showHistoricalModal} onHide={() => setShowHistoricalModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Historical Manual Validations vs AI Detected</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-3">
                        <Col xs={12} md={6}>
                            <Form.Group>
                                <Form.Label>Start Date</Form.Label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    maxDate={endDate}
                                    wrapperClassName="w-100"
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                            <Form.Group>
                                <Form.Label>End Date</Form.Label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    minDate={startDate}
                                    maxDate={new Date()}
                                    wrapperClassName="w-100"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mb-3">
                        <Button
                            variant="primary"
                            onClick={async () => {
                                setIsLoadingHistorical(true);
                                try {
                                    // Fetch combined manual and detected counts from unified API
                                    const response = await fetchHistoricalManualValidations(startDate, endDate);
                                    console.log("fetchHistoricalManualValidations response:", response);

                                    // The API returns { success: true, data: { manualCounts: [...], detectedCounts: [...] } }
                                    const apiData = response.data || {};

                                    // Aggregate manual counts (sum all entries in the array)
                                    let aggregatedManual = {
                                        turmericHopper1SackCount: 0,
                                        turmericHopper2SackCount: 0,
                                        corianderSackCount: 0,
                                        rtcGrinding1SackCount: 0,
                                        rtcGrinding1BucketCount: 0,
                                        rtcGrinding2SackCount: 0,
                                        rtcGrinding2BucketCount: 0
                                    };

                                    if (apiData.manualCounts && Array.isArray(apiData.manualCounts)) {
                                        apiData.manualCounts.forEach(item => {
                                            aggregatedManual.turmericHopper1SackCount += Number(item.turmeric_hopper1_sack_count || 0);
                                            aggregatedManual.turmericHopper2SackCount += Number(item.turmeric_hopper2_sack_count || 0);
                                            aggregatedManual.corianderSackCount += Number(item.coriander_sack_count || 0);
                                            aggregatedManual.rtcGrinding1SackCount += Number(item.rtc_grinding1_sack_count || 0);
                                            aggregatedManual.rtcGrinding1BucketCount += Number(item.rtc_grinding1_bucket_count || 0);
                                            aggregatedManual.rtcGrinding2SackCount += Number(item.rtc_grinding2_sack_count || 0);
                                            aggregatedManual.rtcGrinding2BucketCount += Number(item.rtc_grinding2_bucket_count || 0);
                                        });
                                    }

                                    // Aggregate AI detected counts (sum all entries in the array)
                                    let aggregatedDetected = {
                                        turmericHopper1SackCount: 0,
                                        turmericHopper2SackCount: 0,
                                        corianderSackCount: 0,
                                        rtcGrinding1SackCount: 0,
                                        rtcGrinding1BucketCount: 0,
                                        rtcGrinding2SackCount: 0,
                                        rtcGrinding2BucketCount: 0
                                    };

                                    if (apiData.detectedCounts && Array.isArray(apiData.detectedCounts)) {
                                        apiData.detectedCounts.forEach(item => {
                                            aggregatedDetected.turmericHopper1SackCount += Number(item.turmeric_hopper1_sack_count || 0);
                                            aggregatedDetected.turmericHopper2SackCount += Number(item.turmeric_hopper2_sack_count || 0);
                                            aggregatedDetected.corianderSackCount += Number(item.coriander_sack_count || 0);
                                            aggregatedDetected.rtcGrinding1SackCount += Number(item.rtc_grinding1_sack_count || 0);
                                            aggregatedDetected.rtcGrinding1BucketCount += Number(item.rtc_grinding1_bucket_count || 0);
                                            aggregatedDetected.rtcGrinding2SackCount += Number(item.rtc_grinding2_sack_count || 0);
                                            aggregatedDetected.rtcGrinding2BucketCount += Number(item.rtc_grinding2_bucket_count || 0);
                                        });
                                    }

                                    setHistoricalData(aggregatedManual);
                                    setAiDetectedData(aggregatedDetected);
                                } catch (error) {
                                    console.error("Error fetching historical data:", error);
                                } finally {
                                    setIsLoadingHistorical(false);
                                }
                            }}
                            disabled={isLoadingHistorical}
                        >
                            {isLoadingHistorical ? "Loading..." : "Load Comparison"}
                        </Button>
                    </div>

                    {historicalData && aiDetectedData && (
                        <div style={{ overflowX: "auto" }}>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Field</th>
                                        <th>Manual Validation</th>
                                        <th>AI Detected</th>
                                        <th>Difference</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>Turmeric Hopper 1 Sack Count</strong></td>
                                        <td>{historicalData.turmericHopper1SackCount}</td>
                                        <td>{aiDetectedData.turmericHopper1SackCount}</td>
                                        <td style={{
                                            color: Math.abs(historicalData.turmericHopper1SackCount - aiDetectedData.turmericHopper1SackCount) > 0 ? "red" : "green",
                                            fontWeight: "bold"
                                        }}>
                                            {historicalData.turmericHopper1SackCount - aiDetectedData.turmericHopper1SackCount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>Turmeric Hopper 2 Sack Count</strong></td>
                                        <td>{historicalData.turmericHopper2SackCount}</td>
                                        <td>{aiDetectedData.turmericHopper2SackCount}</td>
                                        <td style={{
                                            color: Math.abs(historicalData.turmericHopper2SackCount - aiDetectedData.turmericHopper2SackCount) > 0 ? "red" : "green",
                                            fontWeight: "bold"
                                        }}>
                                            {historicalData.turmericHopper2SackCount - aiDetectedData.turmericHopper2SackCount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>Coriander Sack Count</strong></td>
                                        <td>{historicalData.corianderSackCount}</td>
                                        <td>{aiDetectedData.corianderSackCount}</td>
                                        <td style={{
                                            color: Math.abs(historicalData.corianderSackCount - aiDetectedData.corianderSackCount) > 0 ? "red" : "green",
                                            fontWeight: "bold"
                                        }}>
                                            {historicalData.corianderSackCount - aiDetectedData.corianderSackCount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>RTC Grinding 1 Sack Count</strong></td>
                                        <td>{historicalData.rtcGrinding1SackCount}</td>
                                        <td>{aiDetectedData.rtcGrinding1SackCount}</td>
                                        <td style={{
                                            color: Math.abs(historicalData.rtcGrinding1SackCount - aiDetectedData.rtcGrinding1SackCount) > 0 ? "red" : "green",
                                            fontWeight: "bold"
                                        }}>
                                            {historicalData.rtcGrinding1SackCount - aiDetectedData.rtcGrinding1SackCount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>RTC Grinding 1 Bucket Count</strong></td>
                                        <td>{historicalData.rtcGrinding1BucketCount}</td>
                                        <td>{aiDetectedData.rtcGrinding1BucketCount}</td>
                                        <td style={{
                                            color: Math.abs(historicalData.rtcGrinding1BucketCount - aiDetectedData.rtcGrinding1BucketCount) > 0 ? "red" : "green",
                                            fontWeight: "bold"
                                        }}>
                                            {historicalData.rtcGrinding1BucketCount - aiDetectedData.rtcGrinding1BucketCount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>RTC Grinding 2 Sack Count</strong></td>
                                        <td>{historicalData.rtcGrinding2SackCount}</td>
                                        <td>{aiDetectedData.rtcGrinding2SackCount}</td>
                                        <td style={{
                                            color: Math.abs(historicalData.rtcGrinding2SackCount - aiDetectedData.rtcGrinding2SackCount) > 0 ? "red" : "green",
                                            fontWeight: "bold"
                                        }}>
                                            {historicalData.rtcGrinding2SackCount - aiDetectedData.rtcGrinding2SackCount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>RTC Grinding 2 Bucket Count</strong></td>
                                        <td>{historicalData.rtcGrinding2BucketCount}</td>
                                        <td>{aiDetectedData.rtcGrinding2BucketCount}</td>
                                        <td style={{
                                            color: Math.abs(historicalData.rtcGrinding2BucketCount - aiDetectedData.rtcGrinding2BucketCount) > 0 ? "red" : "green",
                                            fontWeight: "bold"
                                        }}>
                                            {historicalData.rtcGrinding2BucketCount - aiDetectedData.rtcGrinding2BucketCount}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowHistoricalModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


        </div>
    );
}
